export const environment = {
  toolboxApiEndpoint: 'https://toolbox-dev.projects.holycode.com/api',
  authTenantEndpoint: ' https://custom-stage.maxbrain.io/electrosuisse',
  clientId: 'toolbox-confidential-client',
  redirectUri: 'https://toolbox-dev.projects.holycode.com/callback',
  postLogoutRedirectUri: 'https://www.electrosuisse.ch/de/logout/',
};
